import React from "react";

import {
    FaFileInvoiceDollar,
    FaMoneyBillWave,
    FaShoppingCart,
    FaUserPlus,
    FaWallet,
} from "react-icons/fa";

import MetricCard from "./MetricCard";

import {
    formatCurrency,
    formatNumber,
} from "../utils/dashboardFormatters";


const PERIOD_LABELS = {
    TODAY: {
        heading:
            "Today's Performance",

        indicator:
            "Today",

        sales:
            "Today's Sales",

        userSubtitle:
            "Registered today",
    },

    YESTERDAY: {
        heading:
            "Yesterday's Performance",

        indicator:
            "Yesterday",

        sales:
            "Sales",

        userSubtitle:
            "Registered yesterday",
    },

    THIS_WEEK: {
        heading:
            "This Week's Performance",

        indicator:
            "This Week",

        sales:
            "Sales",

        userSubtitle:
            "Registered this week",
    },

    THIS_MONTH: {
        heading:
            "This Month's Performance",

        indicator:
            "This Month",

        sales:
            "Sales",

        userSubtitle:
            "Registered this month",
    },

    THIS_YEAR: {
        heading:
            "This Year's Performance",

        indicator:
            "This Year",

        sales:
            "Sales",

        userSubtitle:
            "Registered this year",
    },

    CUSTOM: {
        heading:
            "Selected Period Performance",

        indicator:
            "Selected Period",

        sales:
            "Sales",

        userSubtitle:
            "Registered in selected period",
    },
};


const TodaySnapshot = ({
    priority = {},
    period = "TODAY",
}) => {

    const normalizedPeriod =
        String(
            period ||
            "TODAY"
        )
            .trim()
            .toUpperCase();


    const labels =
        PERIOD_LABELS[
            normalizedPeriod
        ] ||
        PERIOD_LABELS.CUSTOM;


    return (

        <section
            className="dashboard-today-section"
        >

            <div
                className="dashboard-section-heading"
            >

                <div>

                    <span
                        className="dashboard-heading-eyebrow"
                    >
                        BUSINESS SNAPSHOT
                    </span>

                    <h2>
                        {labels.heading}
                    </h2>

                </div>

                <span
                    className="dashboard-live-indicator"
                >
                    <i />
                    {labels.indicator}
                </span>

            </div>


            <div
                className="dashboard-priority-grid"
            >

                <MetricCard
                    title={
                        labels.sales
                    }
                    value={
                        formatCurrency(
                            priority
                                ?.todaySales
                        )
                    }
                    icon={
                        FaMoneyBillWave
                    }
                    emphasis
                />


                <MetricCard
                    title="Invoices"
                    value={
                        formatNumber(
                            priority
                                ?.todayInvoices
                        )
                    }
                    icon={
                        FaFileInvoiceDollar
                    }
                />


                <MetricCard
                    title="Collection"
                    value={
                        formatCurrency(
                            priority
                                ?.todayCollection
                        )
                    }
                    icon={
                        FaWallet
                    }
                />


                <MetricCard
                    title="Outstanding"
                    value={
                        formatCurrency(
                            priority
                                ?.todayOutstanding
                        )
                    }
                    icon={
                        FaWallet
                    }
                />


                <MetricCard
                    title="Website Orders"
                    value={
                        formatNumber(
                            priority
                                ?.todayWebsiteOrders
                        )
                    }
                    subtitle={
                        formatCurrency(
                            priority
                                ?.todayWebsiteOrderAmount
                        )
                    }
                    icon={
                        FaShoppingCart
                    }
                    emphasis
                />


                <MetricCard
                    title="New Website Users"
                    value={
                        formatNumber(
                            priority
                                ?.todayNewWebsiteUsers
                        )
                    }
                    subtitle={
                        labels
                            .userSubtitle
                    }
                    icon={
                        FaUserPlus
                    }
                    emphasis
                />

            </div>

        </section>

    );

};

export default TodaySnapshot;